import type { TextInputProps } from "@-/com.npmjs.react-native";
import { cn } from "@-/com.npmjs.cn";
import { Platform, TextInput } from "@-/com.npmjs.react-native";

export function Textarea({
  className,
  multiline = true,
  numberOfLines = Platform.select({ native: 8, web: 2 }), // On web, numberOfLines also determines initial height. On native, it determines the maximum height.
  /** When set, `numberOfLines` is not passed — use with explicit `style` height so the field scrolls inside a fixed box (e.g. dialogs). */
  fixedHeightBox = false,
  style,
  ...props
}: TextInputProps &
  React.RefAttributes<TextInput> & {
    fixedHeightBox?: boolean;
  }) {
  return (
    <TextInput
      className={cn(
        // Avoid flex-row on native TextInput — it can shrink the field to intrinsic width instead of filling the row.
        "min-h-16 w-full max-w-full min-w-0 self-stretch rounded-xs border border-input bg-transparent px-3 py-2 font-sans text-base text-foreground shadow-sm shadow-black/5 md:text-sm dark:bg-input/30",
        Platform.select({
          web: "placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive field-sizing-fixed resize-y outline-none transition-[color,box-shadow] focus-visible:ring-[3px] disabled:cursor-not-allowed",
        }),
        props.editable === false && "opacity-50",
        className,
      )}
      multiline={multiline}
      {...(fixedHeightBox ? {} : { numberOfLines })}
      style={[
        Platform.OS !== "web"
          ? ({
              alignSelf: "stretch",
              flexShrink: 1,
              maxWidth: "100%",
              minWidth: "100%",
              width: "100%",
            } as const)
          : ({ flexShrink: 1, maxWidth: "100%", minWidth: 0, width: "100%" } as const),
        style,
      ]}
      textAlignVertical="top"
      {...props}
    />
  );
}
